<template>
        <v-row>
          <v-col>
            <v-sheet
              min-height="10vh"
              rounded="lg"
            >
              <div class="settings-title pt-6">{{ $t('settings.' + $route.meta.title + '.title') }}</div>
              <router-view />
            </v-sheet>
          </v-col>

          <v-col cols="3 d-none d-md-block">
            <v-sheet class="settings-menu" rounded="lg">
              <settingsMenu class="transparent" />
            </v-sheet>
          </v-col>
        </v-row>
</template>

<script>
import settingsMenu from '@/components/settings/menu';

export default {
  name: 'SettingsWrapper',

  components: {
    settingsMenu,
  },
};
</script>

<style lang="scss" scoped>
.settings-title {
  font-weight: 600;
font-size: 20px;
line-height: 24px;
/* identical to box height, or 120% */

text-align: center;

/* Text / Gray */

color: #44445E;
}
</style>
